import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { notice, alert } from 'ducks/notifications';
import { reduxForm, formValueSelector } from 'redux-form';
import convertToFormErrors from 'utils/convertToFormErrors';
import Field from 'form/Field';
import Form from 'form/Form';
import SubmitButton from 'form/SubmitButton';
import { query } from 'redux-bees';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import loadStripe from 'utils/loadStripe';
import CreditCardInput from 'form/CreditCardInput';
import validateCardNumber from 'stripe-card-validator';
import MaskedInput from 'react-text-mask';
import queryString from 'query-string';
import Cards from 'react-credit-cards';


const selector = formValueSelector('EditCardInfo');

@withRouter

@query('billingProfile', api.getBillingProfile)

@connect(state => ({
  cardNumber: selector(state, 'cardNumber'),
  cardHolder: selector(state, 'cardHolder'),
  cardExpiryDate: selector(state, 'cardExpiryDate'),
  cardCvc: selector(state, 'cardCvc'),
}))

@reduxForm({
  form: 'EditCardInfo',
  onSubmit(values, dispatch, props) {
    const [cardMonth, cardYear] = values.cardExpiryDate.split('/').map(part => part.trim());

    const fields = {
      number: values.cardNumber,
      exp_month: cardMonth,
      exp_year: cardYear,
      cvc: values.cardCvc,
      name: values.cardHolder,
    };

    const parsedQuery = queryString.parse(props.location.search);

    return new Promise((resolve, reject) => {
      window.Stripe.card.createToken(fields, (status, response) => {
        if (response.error) {
          reject({
            body: {
              errors: [
                {
                  code: `STRIPE_${response.error.code.toUpperCase()}`,
                },
              ],
            },
          });
        } else {
          resolve(response.id);
        }
      });
    })
    .then(cardToken => (
      dispatch(api.updateCardInfo(
        {
          data: {
            type: 'updateCardInfo',
            attributes: { cardToken },
          },
        },
      ))
    ))
    .then(() => {
      props.history.push(parsedQuery.returnTo || '/account');
      dispatch(notice('BillingInfo.success'));
    })
    .catch((response) => {
      dispatch(alert(response.body.errors[0].code));
      return Promise.reject(convertToFormErrors(response));
    });
  },
})


export default class EditCardInfo extends Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    dirty: PropTypes.bool.isRequired,
    error: PropTypes.string,
    cardNumber: PropTypes.string,
    cardHolder: PropTypes.string,
    cardExpiryDate: PropTypes.string,
    cardCvc: PropTypes.string,
  }

  componentDidMount() {
    loadStripe();
    this.state = {
      focused: '',
    };
  }

  handleInputFocus(name) {
    this.setState({
      focused: name,
    });
  }

  handleInputBlur() {
    this.setState({
      focused: '',
    });
  }


  renderLoading() {
    return <span>Loading..</span>;
  }

  render() {
    const {
      handleSubmit,
      submitting,
      error,
      dirty,
      cardNumber,
      cardHolder,
      cardExpiryDate,
      cardCvc,
    } = this.props;

    let cardType;

    try {
      cardType = validateCardNumber(cardNumber || '');
    } catch (e) {
      cardType = null;
    }

    const cvcMask = cardType === 'american express' ? '1234' : '123';

    const realMask = [];
    for (let i = 0; i < cvcMask.length; i += 1) {
      realMask.push(/\d/);
    }

    return (
      <div>
        <div className="grid__item width-6-12">
          <Form error={error} onSubmit={handleSubmit}>
            <Field name="cardNumber" onFocus={this.handleInputFocus.bind(this, 'number')}>
              <CreditCardInput
                className="form__input form__input--small"
              />
            </Field>
            <Field name="cardHolder" placeholder="Name" onFocus={this.handleInputFocus.bind(this, 'name')}>
              <input type="text" className="form__input form__input--small" />
            </Field>
            <div className="grid space--bottom-2">
              <div className="grid__item width-8-12">
                <Field name="cardExpiryDate" placeholder="Valid Thru" onFocus={this.handleInputFocus.bind(this, 'expiry')}>
                  <MaskedInput
                    type="text"
                    className="form__input form__input--small"
                    mask={[/\d/, /\d/, '/', /\d/, /\d/]}
                  />
                </Field>
              </div>
              <div className="grid__item width-4-12">
                <Field name="cardCvc" placeholder="CVC" onFocus={this.handleInputFocus.bind(this, 'cvc')} onBlur={this.handleInputBlur.bind(this)} >
                  <MaskedInput
                    type="text"
                    className="form__input form__input--small"
                    mask={realMask}
                  />
                </Field>
              </div>
            </div>
            <SubmitButton
              dirty={dirty}
              className="button button--primary button--expand"
              submitting={submitting}
              label="EditCardInfo.submit"
            />
          </Form>
        </div>
        <div className="grid__item width-6-12">
          { this.state &&
            <Cards
              number={cardNumber || ''}
              name={cardHolder || ''}
              expiry={cardExpiryDate || ''}
              cvc={cardCvc || ''}
              focused={this.state.focused}
            />
          }
          <div className="EditCardInfo__stripe">
            <img src="/assets/images/creditcard/stripe.svg" alt="" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EditCardInfo.jsx